import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import '../node_modules/bootstrap-icons/font/bootstrap-icons.css'
 createApp(App).use(router).mount('#app')
